module.exports = __webpack_public_path__ + "lit_001.e352fb47.webp";